var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCallIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.965 16.6544L17.792 15.4814C17.206 14.8954 16.256 14.8954 15.671 15.4814L14.749 16.4034C14.543 16.6094 14.231 16.6784 13.965 16.5614C12.629 15.9764 11.309 15.0894 10.132 13.9124C8.96002 12.7404 8.07602 11.4264 7.49002 10.0954C7.36802 9.82037 7.43902 9.49737 7.65202 9.28437L8.47802 8.45837C9.14902 7.78737 9.14902 6.83837 8.56302 6.25237L7.39002 5.07937C6.60902 4.29837 5.34302 4.29837 4.56202 5.07937L3.91002 5.73037C3.16902 6.47137 2.86002 7.54037 3.06002 8.60037C3.55402 11.2134 5.07202 14.0744 7.52102 16.5234C9.97002 18.9724 12.831 20.4904 15.444 20.9844C16.504 21.1844 17.573 20.8754 18.314 20.1344L18.965 19.4834C19.746 18.7024 19.746 17.4364 18.965 16.6544V16.6544Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.03537C14.031 7.02137 15.067 7.40337 15.854 8.19037",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.682 5.36237C17.113 3.79337 15.056 3.00837 13 3.00837",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.009 11.0444C17.023 10.0134 16.641 8.97737 15.854 8.19037",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.682 5.36237C20.251 6.93137 21.036 8.98837 21.036 11.0444",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CallIcon.335a2810.svg";
export { ForwardRef as ReactComponent };